import { Modal, Button } from "antd";

interface IProps {
  visualizar: boolean;
  setVisualizar: any;
}
import Inversion from "../../../assets/comunas/inversionporarea.png"

export const ModalVisualizarInversion: React.FC<IProps> = (props: IProps) => {

  const onCancel = () => {
    props.setVisualizar(false)
  }

  return (
    <Modal
      className="ant-modal-close-x2"
      maskStyle={{
        backgroundColor: "rgba(6, 100, 144 ,0.71)",
      }}
      visible={props.visualizar}
      onCancel={onCancel}
      width={800}
      footer={[
        <Button key="B_CERRAR_1" className="button-gray-ghost m-0" onClick={onCancel}>
          Cerrar
        </Button>,
      ]}
      cancelButtonProps={{ style: { display: "none" } }}
    >
      <div style={{ textAlign: 'center', fontSize: '1.2em' }}>
        <span className="pb-3 font-size-20px font-family-Montserrat-SemiBold">
          Inversión por expresiones
        </span>
        <img src={Inversion} style={{maxWidth: '100%'}} alt="inversion comunas"></img>
      </div>
    </Modal>
  );
};
